/* eslint-disable */
import { cn } from '@/lib/utils'
import { CircleCheck, ClipboardList, Percent } from 'lucide-react';
import { useEffect, useState } from 'react';


export const DynamicIcon = ({ name, ...props }) => {
    const [IconComponent, setIconComponent] = useState(null);

    useEffect(() => {
      if (name) {
        import('lucide-react')
          .then((module) => {
            const Icon = module[name]; // Get the icon dynamically
            if (Icon) {
              setIconComponent(() => Icon); // Set it in state
            } else {
              console.error(`Icon '${name}' not found in lucide-react.`);
            }
          })
          .catch((error) => console.error('Error loading icon:', error));
      }
    }, [name]);
  
    return IconComponent ? <IconComponent {...props} /> : null;
  };
  
const MetricCard = (props) => {
    const {
        data,
        tabType = '',
    } = props;

    const iconComponent = (icon) => {
        switch (icon) {
            case 'ClipboardList':
                return <ClipboardList size={20} />
            case 'CircleCheck':
                return <CircleCheck size={20} />
            case 'percent':
                return <Percent size={20} />
        }
    }
    return (
            <>
              {tabType === 'stats' ? (
                <div className="bg-yellow-50 rounded-lg  border-2 border-slate-200 p-2 flex-1">
                <div className="flex flex-row items-center justify-between">
                  <div className="flex flex-row items-center gap-2">
                      {iconComponent(data?.icon)}
                    <p className="text-sm font-medium text-gray-500">{data.label}</p>
                  </div>
                  <p className="text-lg font-medium">{data.value}</p>
                </div>
              </div>
              ) : (
                <div style={{ backgroundColor: data.bgColor }}>
                <div className='flex flex-row items-center p-2 justify-between'>
                 <div className='flex flex-row items-center gap-2'>
                    <DynamicIcon name={data.icon} />
                    {/* <div className={cn('rounded-full', iconStyles[data.variant])}>{data.icon}</div> */}
                    <p className='text-sm font-medium text-muted-foreground'>{data.label}</p>
                </div>
                <p className='text-lg font-medium'>{data.value}</p>
                </div>
                </div>
              )}
            </>
    )
}

export default MetricCard;